/* "Order today to get it by" delivery-date range (from the reference page). */
(() => {
    const managerKey = '__ebmsShipV4Manager';
    const rootSelector = '[data-ebms-ship-v4]';

    if (
      window[managerKey] &&
      typeof window[managerKey].boot === 'function'
    ) {
      window[managerKey].boot(document);
      return;
    }

    const collectRoots = scope => {
      const roots = [];

      if (
        scope &&
        scope.nodeType === 1 &&
        typeof scope.matches === 'function' &&
        scope.matches(rootSelector)
      ) {
        roots.push(scope);
      }

      if (
        scope &&
        typeof scope.querySelectorAll === 'function'
      ) {
        roots.push(...scope.querySelectorAll(rootSelector));
      }

      return roots;
    };

    const addDays = (startingDate, totalDays) => {
      const date = new Date(startingDate);
      date.setDate(date.getDate() + totalDays);
      return date;
    };

    const getDeliveryRange = () => {
      const today = new Date();

      today.setHours(12, 0, 0, 0);

      let longerWindow = false;
      try {
        const group = window.igData?.user?.getTestGroup?.('bc1a5145-0aea-47a4-90b1-e03f45d60359');
        longerWindow = group?.id === 'd8954ae5-fb6d-4969-bbb7-6f4fad0dd72f';
      } catch (_) {}
      return {
        earliest: addDays(today, longerWindow ? 7 : 4),
        latest: addDays(today, longerWindow ? 12 : 9)
      };
    };

    const formatDate = date =>
      date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric'
      });

    const updateRoot = root => {
      const earliestEl = root.querySelector(
        '[data-ebms-ship-earliest]'
      );

      const latestEl = root.querySelector(
        '[data-ebms-ship-latest]'
      );

      if (!earliestEl || !latestEl) return;

      const range = getDeliveryRange();

      earliestEl.textContent = formatDate(range.earliest);
      latestEl.textContent = formatDate(range.latest);
    };

    const manager = {
      boot(scope = document) {
        collectRoots(scope).forEach(updateRoot);
      }
    };

    window[managerKey] = manager;

    document.addEventListener(
      'shopify:section:load',
      event => {
        manager.boot(event.target || document);
      }
    );

    window.addEventListener(
      'pageshow',
      () => {
        manager.boot(document);
      }
    );

    document.addEventListener(
      'visibilitychange',
      () => {
        if (!document.hidden) {
          manager.boot(document);
        }
      }
    );

    manager.boot(document);
  })();
